import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import Text from '../../../../../../../../global/text/text';
import DefaultButton from '../../../../../../../../global/default-button/default-button';
import { ISpeakerReferenceDTO } from '../../../../../../../../../api/event-hubs.dao';
import { EDIT_TEXT, REMOVE_TEXT } from '../../../../../../../../../constants/common-labels.constants';
import './speakers-list.scss';

type SpeakersListProps = {
    speakers: ISpeakerReferenceDTO[];
    onRemove: (accountContactId: number) => void;
    onEdit: (accountContactId: number) => void;
};

const SpeakersList: React.FC<SpeakersListProps> = observer(({ speakers, onRemove, onEdit }) => {
    if (!speakers.length) return null;

    return (
        <div className='speakers-list'>
            {speakers.map(speaker => (
                <div key={speaker.accountContactId} className='speakers-list__row'>
                    <Text message={`${speaker.firstName} ${speaker.lastName}`} withEllipsis />
                    <div className='speakers-list__actions'>
                        <DefaultButton
                            modifier='remove'
                            className='speakers-list__remove'
                            text={<FormattedMessage {...REMOVE_TEXT} />}
                            onClick={() => onRemove(speaker.accountContactId)}
                        />
                        <DefaultButton
                            modifier='slim'
                            className='speakers-list__edit'
                            text={<FormattedMessage {...EDIT_TEXT} />}
                            onClick={() => onEdit(speaker.accountContactId)}
                        />
                    </div>
                </div>
            ))}
        </div>
    );
});

export { SpeakersList };
